interface EnvironmentConfig {
  appToken: string;
}

/**
 * Get cookie value by name
 */
const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

/**
 * Get app access token from browser cookies
 * Priority: Cookies > env variable
 */
const getAppAccessToken = (): string => {
  // 1. Check cookies first (Application tab > Cookies)
  const cookieToken = getCookie('app_access_token');
  if (cookieToken) {
    return cookieToken;
  }

  // 2. Fall back to environment variable
  const envToken = 'test_token';
  return envToken;
};

const getEnvironmentConfig = (): EnvironmentConfig => {
  const appToken = getAppAccessToken();

  if (!appToken) {
    throw new Error('VITE_APP_TOKEN is not defined in environment variables');
  }

  return {
    appToken
  };
};

export const env = getEnvironmentConfig();
